import { Component, input } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { PaymentOptionInfo } from '../../../../../model/common.model';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'option-content',
    templateUrl: 'option-content.component.html',
    styleUrls: ['./option-content.component.scss'],
    imports: [TranslateModule],
})
export class OptionContentComponent {
    usedOption = input<PaymentOptionInfo>();
    isUSLabel = input<boolean>(false);
}
